<template>
  <div class="spell-bar text-white overflow-y-auto">
    <div  class="container m-auto">
      <div class="">
        <div class="flex flex-wrap gap-4 pb-6">
          <router-link
            to="/spells/create/text"
            v-if="isPaidCustomer"
            class="mr-4 p-4 spell-tile no-underline mb-4 text-reminder">
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/REMINDER_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">Text Reminder</div>
                <t-text lvl="2" class="text-white">Need a nudge? It could make all the difference.</t-text>
              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
            </div>
          </router-link>

          <router-link
            to="/spells/create/reminder-email"
            class="mr-4 p-4 spell-tile no-underline mb-4 text-reminder">
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/EVENTS1_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">Email Reminder</div>
                <t-text lvl="2" class="text-white">Another kind of nudge. Don't forget to reply.</t-text>
              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
            </div>
          </router-link>


          <router-link
            to="/spells/create/connection-send"
            class="mr-4 p-4 spell-tile no-underline mb-4 text-reminder">
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/EVENTS2_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">Connection Reminder</div>
                <t-text lvl="2" class="text-white">Send a reminder to your various connections.</t-text>
              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
            </div>
          </router-link>

          <router-link
            to="/spells/create/note"
            class="p-4 mr-4 mb-4 no-underline spell-tile email-digest self-stretch">
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/REPEATING_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">Repeating Note</div>
                <t-text lvl="2" class="text-white">Need the same Todo added to your list every week?</t-text>
              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
            </div>
          </router-link>
          <router-link
            to="/spells/create/email"
            class="p-4 mr-4 no-underline spell-tile mb-4 email-digest self-stretch">
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/DIGEST_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">Email Digest</div>

                <t-text lvl="2" class="text-white">What&rsquo;s the use of writing it down if you never look at it?</t-text>

              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
            </div>
          </router-link>

          <router-link
            to="/spells/create/todo"
            class="p-4 mr-4 no-underline spell-tile mb-4 email-digest self-stretch">
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/TODO_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">Todo Email</div>
                <t-text lvl="2" class="text-white">What needs to be done today? Sent directly to your inbox.</t-text>
              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
            </div>
          </router-link>

          <router-link
            to="/spells/create/done"
            class="p-4 mr-4 no-underline spell-tile email-digest self-stretch">
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/DONE_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">Done Email</div>
                <t-text lvl="2" class="text-white">What did you accomplish? Take a minute to celebrate what you&rsquo;ve done.</t-text>
              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
            </div>
          </router-link>

          <router-link
            v-if="isPaidCustomer"
            to="/spells/create/api"
            class="p-4 mr-4 no-underline spell-tile email-digest self-stretch">
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/DEFAULT_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">API</div>
                <t-text lvl="2" class="text-white">Create, edit and retrieve your notes programatically.</t-text>
              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
            </div>
          </router-link>

          <router-link
            to="/subscribe"
            v-if="!isPaidCustomer"
            class="p-4 mr-4 no-underline spell-tile email-digest self-stretch promo">

            
            <div class="flex flex-col justify-between h-full">
              <div>
                <img src="/SIGN_300.png" width="auto" />
                <div class="text-white pb-2 font-bold text-base">Want more?</div>
                <t-text lvl="2" class="text-white">Upgrade to get more Spells.</t-text>
              </div>
              <div
                class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Upgrade</div>
            </div>

            
          </router-link>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
 import {mapGetters, mapState} from 'vuex';
 export default {
   computed: {
     ...mapState({
       member: state => state.member
     }),
     ...mapGetters(['isPaidCustomer'])
   }
 }
</script>


<style scoped>

 img {
   display: block;
   margin: 20px auto;
 }

 .spell-bar {
   
 }

 .spell-tile {
   background: #000;
   border-radius: 4px;
   min-width: 175px;
   width: 175px;
   display: block;
   color: #fff;
 }

 .spell-tile.promo {
   background: #0000ff;
 }
 
 .email-digest {

 }

 .text-reminder {
   
 }
</style>
